const sg_broker_origin =
    process.env.NODE_ENV === 'production'
        ? 'https://netseidbroker.dk'
        : 'https://pp.netseidbroker.dk';
const sg_broker_id_token_endpoint = `${sg_broker_origin}/op/api/v1/tokenverify`;
const sg_broker_redirect_uri = `${sg_broker_origin}/op/WebMessagingCallback/ImplicitCallback`;
const sg_broker_authorize_endpoint = `${sg_broker_origin}/op/connect/authorize`;
const sg_broker_clientId =
    process.env.NODE_ENV === 'production'
        ? 'b35a3fff-7dd9-4441-8426-457562027b48'
        : '9d3c7d79-96c4-43bc-8562-f0bf88ef69b8';
const sg_broker_demo_age_to_verify = 18;

export {
    sg_broker_origin,
    sg_broker_id_token_endpoint,
    sg_broker_redirect_uri,
    sg_broker_authorize_endpoint,
    sg_broker_clientId,
    sg_broker_demo_age_to_verify,
};
